export * from '@platform/services/confirmation/public-api';
